/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-unused-vars
export const sendError = (error, info) => {
};
